import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { createPinia, PiniaVuePlugin } from "pinia";
import VueCompositionAPI from "@vue/composition-api";
import i18n from "./i18n";
import resetStore from "@/store/resetStore";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import VueKeyCloak from "@dsb-norge/vue-keycloak-js";
import axios from "axios";

Vue.use(Toast);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(resetStore);
Vue.use(VueCompositionAPI);

Vue.config.productionTip = false;

function tokenInterceptor() {
  axios.interceptors.request.use(
    (config) => {
      if (Vue.prototype.$keycloak.authenticated) {
        config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

Vue.use(VueKeyCloak, {
  config: {
    realm: process.env.VUE_APP_REALM,
    url: process.env.VUE_APP_KEYCLOAK_URL,
    clientId: process.env.VUE_APP_CLIENT_ID,
  },
  onReady: () => {
    tokenInterceptor();
    new Vue({
      router,
      vuetify,
      pinia,
      i18n,
      render: (h) => h(App),
    }).$mount("#app");
  },
});
